import { Handle, Position } from 'react-flow-renderer';

import BaseNode from './base-node';

type Props = {
  targetPosition: Position | any;
  sourcePosition: Position | any;
  data: {
    superHeading: string;
    title: string;
    childrenCount?: number;
  } & any;
};

export const CustomNode = ({
  targetPosition = Position.Top,
  sourcePosition = Position.Bottom,
  data,
}: Props): React.ReactElement => {
  return (
    <>
      <Handle type='target' position={targetPosition} />
      <BaseNode data={data} />
      <Handle type='source' position={sourcePosition} id='a' />
    </>
  );
};
